<template>
  <b-row>
    <!-- Simbolo Copago -->
    <b-col cols="auto" class="px-0 border-right" v-if="mostrarCopago">
      <div
        :id="rbd + '-copago'"
        v-b-tooltip.hover
        :title="tooltipCopago()"
        class="btn-ficha d-flex rounded-circle my-0 d-inline-block mx-auto h5"
        :class="{
          'text-azul-medio': !esGratuito,
          'text-gris-light': esGratuito
        }"
      >
        <span class="align-self-center mx-auto">
          <FontAwesomeIcon icon="dollar-sign"></FontAwesomeIcon>
        </span>
      </div>
    </b-col>
    <!-- Simbolo Género -->
    <b-col cols="auto" class="px-0 border-right">
      <div
        :id="rbd + '-genero'"
        v-b-tooltip.hover
        :title="tooltipGenero()"
        class="btn-ficha text-azul-medio my-0 d-flex d-inline-block mx-auto h5"
      >
        <span class="align-self-center mx-auto">
          <FontAwesomeIcon
            v-if="genero === 'Hombres'"
            icon="male"
          ></FontAwesomeIcon>
          <FontAwesomeIcon
            v-else-if="genero === 'Mujeres'"
            icon="female"
          ></FontAwesomeIcon>
          <FontAwesomeIcon v-else icon="restroom"></FontAwesomeIcon>
        </span>
      </div>
    </b-col>
    <!-- Simbolo SEP -->
    <b-col cols="auto" class="px-0 border-right">
      <div
        :id="rbd + '-sep'"
        v-b-tooltip.hover
        :title="tooltipSep()"
        class="btn-ficha d-flex d-inline-block mx-auto my-0"
        :class="{
          'text-azul-medio font-weight-bold': subvencionPreferencial,
          'text-gris-light': !subvencionPreferencial
        }"
      >
        <span class="align-self-center mx-auto">SEP</span>
      </div>
    </b-col>

    <!-- Simbolo PIE -->
    <b-col cols="auto" class="px-0">
      <div
        :id="rbd + '-pie'"
        v-b-tooltip.hover
        :title="tooltipPie()"
        class="btn-ficha d-flex d-inline-block mx-auto my-0"
        :class="{
          'text-azul-medio font-weight-bold': integracionEscolar,
          'text-gris-light': !integracionEscolar
        }"
      >
        <span class="align-self-center mx-auto">PIE</span>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faDollarSign,
  faRestroom,
  faMale,
  faFemale
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add(faDollarSign, faRestroom, faMale, faFemale);
export default {
  props: {
    posicionTooltip: {
      type: String,
      required: true
    },
    rbd: {
      type: Number,
      required: true
    },
    mostrarCopago: {
      type: Boolean,
      required: false,
      default: true
    },
    esGratuito: {
      type: Boolean,
      required: false,
      default: true
    },
    genero: {
      type: String,
      required: true
    },
    subvencionPreferencial: {
      type: Boolean,
      default: false
    },
    integracionEscolar: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  components: {
    FontAwesomeIcon
  },
  methods: {
    //calcula texto para tooltip copago
    tooltipCopago: function() {
      return this.esGratuito ? "Sin copago" : "Con copago";
    },
    //calcula texto para tooltip genero
    tooltipGenero: function() {
      switch (this.genero) {
        case "Hombres":
          return "Sólo hombres";
        case "Mujeres":
          return "Sólo mujeres";
        default:
          return "Mixto";
      }
    },
    //calcula texto para tooltip SEP
    tooltipSep: function() {
      return this.subvencionPreferencial
        ? "Con Subvención Escolar Preferencial"
        : "Sin Subvención Escolar Preferencial";
    },
    //calcula texto para tooltip pie
    tooltipPie: function() {
      return this.integracionEscolar
        ? "Con Programa de Integración Escolar"
        : "Sin Programa de Integración Escolar";
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/generales/Simbologia.vue